<script lang="ts" setup>
</script>

<template>
  <div v-once>
    <div class="mx-auto my-40 max-w-1200">
      <h1 class="text-center">开放原子开源基金会品牌使用指南</h1>
      <p class="text-center">版本号: 2.1</p>
      <p class="text-center">发布时间: 2025年7月22日</p>
      <p class="indent-2em">
        开放原子开源基金会（下称“<strong>基金会</strong>”）作为中立、开放的非营利组织，享有本基金会及本基金会孵化运营的各开源项目相关商标和字号的标识性权利/权益（下称“<strong>基金会品牌</strong>”），具体范围请参见附件1《基金会品牌标识清单》。
      </p>
      <p class="indent-2em">
        为维护本基金会品牌的合法商誉和品牌价值，基金会特拟定本《开放原子开源基金会品牌使用指南》（下称"<strong>本指南</strong>"），希望与所有参与开源生态建设的贡献者和社区伙伴（下称"<strong>您</strong>"）共同合法、规范地使用本基金会品牌。
      </p>

      <h4>二、适用对象</h4>

      <p class="indent-2em">
        本指南适用于与本基金会及本基金会孵化运营的各开源项目相关的所有组织、单位和个人，包括但不限于本基金会合作伙伴、各开源项目工作委员会及下设组织、开源项目成员单位、开源项目捐赠人、开源项目生态贡献者。
      </p>

      <h4>三、使用规范</h4>

      <p class="indent-2em">
        除本条第2款明确规定无须授权即可使用的情形外，您使用本基金会品牌前均应与本基金会或对应的开源项目进行沟通，取得相应的授权，并在获得授权后按照本基金会品牌的视觉规范使用对应标识的标准式样。基金会品牌使用共分为以下三种情形：
      </p>

      <h4>1. 禁止使用的情形</h4>

      <ul>
        <li>
          <p>
            禁止以移除、扭曲或篡改本基金会品牌任何元素的方式变更使用本基金会品牌，包括但不限于改变文字/字母顺序、改变字母大小写、缺省或添加部分文字/字母、以改变文字比例等方式突出使用部分文字/字母、改变颜色、拆分换行等。<br>
            正确示例：<br>
            本基金会的中文全称是“开放原子开源基金会”、英文全称是“OpenAtom Foundation”；可简称为“开放原子”“OpenAtom”。
          </p>
        </li>
        <li>
          <p>
            禁止缺省“开源”等关键字不完整使用本基金会品牌的中文名称。例如在提及“开源鸿蒙”开源项目名称时，应确保始终完整使用“开源鸿蒙”四字，禁止缺省“开源”二字直接使用“鸿蒙”、禁止将“开源鸿蒙”与“鸿蒙”替代或混同使用。
          </p>
        </li>
        <li>
          <p>
            禁止以“本基金会品牌+产品或服务通用名称”的形式使用。<br>
            正确示例：<br>
            －XX手机开源鸿蒙版。
          </p>
        </li>
        <li>
          <p>禁止以任何诽谤、贬损的方式使用本基金会品牌。</p>
        </li>
        <li>
          <p>禁止以任何虚假或误导性宣传方式使用本基金会品牌。</p>
        </li>
        <li>
          <p>禁止使用容易与本基金会品牌混淆的标识、广告语、宣传口号等。</p>
        </li>
        <li>
          <p>禁止通过二次创作或将本基金会品牌作为装饰元素等方式过度使用本基金会品牌。如基于本基金会Logo进行任何二次创作或将其以任何形式作为装饰元素。</p>
        </li>
      </ul>

      <h4>2. 无须授权即可使用的情形</h4>

      <p class="indent-2em">
        以下品牌使用情形无须获得本基金会或对应的开源项目授权，您可以按照本基金会品牌的视觉规范<strong>善意</strong>使用本基金会品牌对应标识的标准式样。
      </p>

      <ul>
        <li>
          <p>
            在宣传材料（如PPT、书籍、宣传册、新闻稿）中以文字形式使用开源项目名称以如实说明相关事实情况。<br>
            正确示例：<br>
            －XXX（某企业全称/商号）是XXX（基金会孵化运营的开源项目名称）的设备开发者/发行版厂商/应用开发者；<br>
            －基于XXX（基金会孵化运营的开源项目名称）的模组/开发板/板卡/设备/整机/商业发行版/商用软件。
          </p>
        </li>
        <li>
          <p>
            在非商业用途的网页上使用本基金会品牌作为指向本基金会及本基金会孵化运营的开源项目官网的超链接按钮（点击后可跳转至本基金会或对应的开源项目官网）。<br>
            正确示例：<br>
            －在进行开源文化推广或学术研讨的网页上，使用本基金会Logo或本基金会孵化运营的开源项目Logo标准样式作为跳转至本基金会官网或对应的开源项目官网的超链接按钮。
          </p>
        </li>
        <li>
          <p>
            为非商业目的制作T恤、帽子等常见文化周边产品，在文化周边产品上印制本基金会品牌，并且未同时出现任何其他品牌。<br>
            正确示例：<br>
            －在开源活动中向参与活动的开源爱好者赠送印制有本基金会Logo或本基金会孵化运营的开源项目Logo的帆布包。
          </p>
        </li>
      </ul>

      <h4>3. 经授权后方可使用的情形</h4>

      <p class="indent-2em">
        除前述无须授权即可使用的情形外，就以下品牌使用情形，您需事先取得本基金会或对应的开源项目的书面授权，并在获得授权后按照本基金会品牌的视觉规范使用对应标识的标准式样：
      </p>

      <ul>
        <li>
          <p>在与各地方政府合作的实体名称、机构/组织/示范区名称中使用本基金会品牌（如XX兼容性测评中心、XX生态服务中心、XX培训中心、XX实训基地、XX创新中心、XX研究院、XX促进中心、XX生态示范区、XX产业小镇、XX之城等）。</p>
        </li>
        <li>
          <p>在社交网络注册名称、域名、IT基础设施中使用本基金会品牌。</p>
        </li>
        <li>
          <p>在荣誉证书、资质证书中使用本基金会品牌。</p>
        </li>
        <li>
          <p>在文化周边产品上，将本基金会品牌与第三方品牌以组合、联名等方式使用。</p>
        </li>
      </ul>

      <h4>四、商标权属标记</h4>

      <p class="indent-2em">
        本基金会享有本基金会品牌全部知识产权及合法权益。欢迎您在使用本基金会品牌时标注商标标记（™），并在同一界面注明："【XXX™】是开放原子开源基金会享有权益的商标"。
      </p>

      <h4>五、授权终止</h4>

      <p class="indent-2em">
        您基于本指南就本基金会品牌所获得的授权为可撤销、非独占、不可转让、不可分许可的普通许可。如您的使用行为存在以下情况的，相应授权立即自动终止：
      </p>

      <ul>
        <li><p>您违反本指南或未按照授权范围使用本基金会品牌。</p></li>
        <li>
          <p>您直接或间接挑战本基金会品牌的商标权或其他合法权益，包括但不限于（a）对基金会的任何商标提起异议、无效、撤销程序；（b）通过注册、转让、转移等方式获取本基金会品牌或与其近似的商标、企业名称、域名、电商店铺名称、社交网络注册名称（如微信、微博名等）或其他商业及非商业标识。</p>
        </li>
        <li>
          <p>您的行为有损本基金会开放、中立、公益、非营利等整体政策、品牌形象，或有损本基金会及本基金会孵化运营的开源项目正当利益。</p>
        </li>
        <li>
          <p>您违反国家法律法规、规章制度或商业道德，或存在其他重大负面新闻。</p>
        </li>
      </ul>

      <h4>六、声明</h4>

      <p class="indent-2em">
        本基金会及本基金会孵化运营的各开源项目社区均不对本基金会品牌的使用做出任何明示或暗示的保证，包括但不限于：本基金会品牌不存在任何知识产权争议的保证、本基金会品牌的任何商标申请均可获得注册商标保护的保证等。
      </p>
      <p class="indent-2em">
        您同意承担使用本基金会品牌的活动或产品相关索赔的所有责任，并承诺使本基金会及本基金会孵化运营的各开源项目、各开源项目的贡献者免于承担任何此类索赔相关责任。本指南的任何内容（含示例）不影响基金会及本基金会孵化运营的各开源项目依法享有的任何权益和主张、不构成任何已有权利的转移。
      </p>

      <h4>七、监督</h4>

      <p class="indent-2em">
        本基金会将对本基金会品牌的使用情况进行不定期抽查，并对违规使用本基金会品牌的行为追究责任。如果您对本指南相关内容有任何疑问，或发现任何疑似侵权使用、违规使用、滥用本基金会品牌的情况，欢迎通过 <a href="mailto:report@openatom.org">report@openatom.org</a> 向我们反馈。
      </p>

      <h4>八、生效与更新</h4>

      <p class="indent-2em">
        本指南的修订权、解释权属于基金会秘书处。本指南经秘书处审议通过、在基金会官网发布后生效。
      </p>
      <p class="indent-2em">
        本指南可能会不定期修订，并在本基金会官方网站发布更新版本。请在每次使用、申请使用本基金会品牌前，请确认您已符合本指南最新版本的要求。
      </p>

      <h4>附件1：基金会品牌标识清单</h4>

      <p>
        <strong>说明</strong>：<br>
        本清单列举了基金会名下的主要品牌标识，但并非基金会全部品牌标识的完整清单。本基金会将对本清单内容进行定期维护、更新。
      </p>

      <table class="mx-auto mt-10px w-80% w-full border-collapse border border-#ddd border-solid">
        <thead>
          <tr class="bg-#f2f2f2">
            <th class="border border-#ddd border-solid p-8px" width="20%">类别</th>
            <th class="border border-#ddd border-solid p-8px">品牌标识</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowspan="6" class="border border-#ddd border-solid p-8px text-center">机构品牌</td>
            <td class="border border-#ddd border-solid p-8px text-center">
              <p>开放原子开源基金会</p>
              <p>OpenAtom Foundation</p>
              <p class="flex-center gap-x-24">
                <img src="@/home/assets/other/brand-guide/1.png" alt="Logo" class="h-30">
                <img src="@/home/assets/other/brand-guide/2.png" alt="Logo" class="h-30">
              </p>
            </td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">AtomGit</td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">
              <p>开放原子校源行</p>
              <p>校源行</p>
            </td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">心寄源</td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">源译识</td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">源规律</td>
          </tr>
          <tr>
            <td rowspan="21" class="border border-#ddd border-solid p-8px text-center">开源项目品牌</td>
            <td class="border border-#ddd border-solid p-8px text-center">
              <p>开源鸿蒙</p>
              <p>OpenHarmony</p>
              <p class="flex-center gap-x-24">
                <img src="@/home/assets/other/brand-guide/3.png" alt="Logo" class="h-30">
                <img src="@/home/assets/other/brand-guide/4.png" alt="Logo" class="h-30">
              </p>
            </td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">
              <p>PikiwiDB</p>
              <p>
                <img src="@/home/assets/other/brand-guide/5.png" alt="Logo" class="h-30">
              </p>
            </td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">hapjs</td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">
              <p>TobudOS</p>
              <p>
                <img src="@/home/assets/other/brand-guide/6.png" alt="Logo" class="h-30">
              </p>
            </td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">
              <p>开源欧拉</p>
              <p>openEuler</p>
              <p class="flex-center gap-x-24">
                <img src="@/home/assets/other/brand-guide/7.png" alt="Logo" class="h-30">
                <img src="@/home/assets/other/brand-guide/8.png" alt="Logo" class="h-30">
              </p>
            </td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">
              <p>狮偶</p>
              <p>
                <img src="@/home/assets/other/brand-guide/9.png" alt="Logo" class="h-30">
              </p>
            </td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">
              <p>铜锁</p>
              <p>Tongsuo</p>
              <p>
                <img src="@/home/assets/other/brand-guide/10.png" alt="Logo" class="h-30">
              </p>
            </td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">源师兄</td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">UBSICE</td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">HyperBench</td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">RT-TKERN</td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">ZTDBP</td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">
              <p>元遨</p>
              <p>Carsmos</p>
              <p>
                <img src="@/home/assets/other/brand-guide/11.png" alt="Logo" class="h-30">
              </p>
            </td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">
              <p>OpenTenBase</p>
              <p>
                <img src="@/home/assets/other/brand-guide/12.png" alt="Logo" class="h-20">
              </p>
            </td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">
              <p>openKylin</p>
              <p>
                <img src="@/home/assets/other/brand-guide/13.png" alt="Logo" class="h-20">
              </p>
            </td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">
              <p>如意玲珑</p>
              <p>Linyaps</p>
              <p>
                <img src="@/home/assets/other/brand-guide/14.png" alt="Logo" class="h-30">
              </p>
            </td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">OpenNJet</td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">PYSTOR DBS</td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">KWDB</td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">Dora SSR</td>
          </tr>
          <tr>
            <td class="border border-#ddd border-solid p-8px text-center">openDACS</td>
          </tr>
        </tbody>
      </table>

      <h4>附件2：品牌使用事宜联系邮箱</h4>

      <ul>
        <li><p><strong>开源鸿蒙</strong>开源项目品牌使用事宜请联系 <a href="mailto:pr@mail.openharmony.io">pr@mail.openharmony.io</a></p></li>
        <li><p><strong>开源欧拉</strong>开源项目品牌使用事宜请联系 <a href="mailto:trademarks@openeuler.sh">trademarks@openeuler.sh</a></p></li>
        <li><p><strong>openKylin</strong>开源项目品牌使用事宜请联系 <a href="mailto:contact@openKylin.top">contact@openKylin.top</a></p></li>
        <li><p><strong>基金会名下其他品牌</strong>的使用事宜请联系 <a href="mailto:tm@openatom.org">tm@openatom.org</a></p></li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
a {
  color: inherit;
  text-decoration: none;
}
</style>
